export default __webpack_public_path__ + "static/media/dashboard.b5297ee8.png";